import API from "shared/services/Api";

import { IClinical, IClinicalResponse } from "shared/types/Clinical";

export const sendClinical = async (
  data: IClinical
): Promise<IClinicalResponse> => API.post("oc/clinical", data);
